
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBeaconMajorSafeWater as ObiSimplifiedBeaconMajorSafeWaterElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-beacon-major-safe-water.js';
 
 
 

 
 export const ObiSimplifiedBeaconMajorSafeWater = createComponent({
   react: React,
   tagName: 'obi-simplified-beacon-major-safe-water',
   elementClass: ObiSimplifiedBeaconMajorSafeWaterElement,
   events: {
     
   }
  });
 
 